import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ShieldCheck, X } from 'lucide-react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('bezalel_cookie_consent');
        if (!consent) {
            // Show banner after a short delay if no choice has been made
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('bezalel_cookie_consent', 'accepted');
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem('bezalel_cookie_consent', 'rejected');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-full duration-500">
            <div className="max-w-6xl mx-auto bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border border-gray-200 p-6 flex flex-col md:flex-row items-center justify-between gap-6">

                <div className="flex items-start gap-4">
                    <div className="p-3 bg-blue-100 rounded-xl text-blue-600 hidden sm:block">
                        <ShieldCheck className="w-6 h-6" />
                    </div>
                    <div>
                        <h3 className="font-bold text-gray-900 mb-1">Tu privacidad nos importa</h3>
                        <p className="text-gray-600 text-sm leading-relaxed max-w-2xl">
                            Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación web,
                            analizar el uso del sitio y ofrecerte contenido personalizado.
                            Al continuar navegando, aceptas nuestra política de privacidad.
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-3 w-full md:w-auto">
                    <Button
                        variant="outline"
                        onClick={handleReject}
                        className="flex-1 md:flex-none border-gray-300 text-gray-700 hover:bg-gray-50"
                    >
                        Rechazar
                    </Button>
                    <Button
                        onClick={handleAccept}
                        className="flex-1 md:flex-none bg-gradient-to-r from-blue-600 to-cyan-500 text-white hover:from-blue-700 hover:to-cyan-600 shadow-md hover:shadow-lg transition-all"
                    >
                        Aceptar todas
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
